import { defineStore } from 'pinia';
import { ref } from 'vue';
import jsonFetch from '@globals/jsonFetch';
import ServiceMessage, { ServiceMessageBackend } from '@globals/types/ServiceMessage';

export const usePromoMessagesStore = defineStore('promoMessages', () => {
	const state = {
		/**
		 * Lista wiadomości.
		 */
		promoMessagesList: ref<ServiceMessage[]>([]),
		/**
		 * Liczba nieprzeczytanych wiadomości.
		 */
		promoMessagesCount: ref(0),
	};

	const actions = {
		/**
		 * Pobiera listę wiadomości z serwera.
		 */
		async update() {
			const result = [] as Array<ServiceMessage>;
			const messages = (await jsonFetch('/profile/messages.do') as Array<ServiceMessageBackend>) || [];
			let readCount = 0;

			for (const msg of (messages || [])) {
				if (msg.moreInfoLink === 'DisplayAppSurvey') {
					const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
					const isCordova = window.localStorage['IsApp'];
					if (navigator.userAgent.indexOf('appstore.oferteo') === -1 && (isSafari || !isCordova)) { continue; }
				}

				result.unshift({
					id: msg.id,
					idUserMessageGroup: msg.idUserMessageGroup,
					type: msg.type || 'info',
					title: msg.title,
					message: msg.message,
					button: msg.buttonLabel || 'Zobacz więcej',
					dismissButton: msg.dismissButtonLabel || 'Przypomnij później',
					action: msg.moreInfoLink,
					date: new Date(msg.tsCreated),
					isRead: msg.read,
				});

				if (msg.read) { readCount++; }
			}

			state.promoMessagesCount.value = result.length - readCount;
			state.promoMessagesList.value = result;
		},

		/**
		 * Oznacza wszystkie wiadomości jako przeczytane.
		 */
		async readAll() {
			state.promoMessagesCount.value = 0;
			await jsonFetch('/profile/messages/read.do', { method: 'POST' });
		},

		/**
		 * Oznacza wiadomość jako przeczytaną.
		 */
		markAsRead(message: ServiceMessage) {
			const { id } = message;
			const foundMessage = state.promoMessagesList.value.find((m) => m.id === id);
			if (foundMessage && !foundMessage.isRead) {
				foundMessage.isRead = true;
				state.promoMessagesCount.value--;
			}
		},
	};

	const getters = {};

	return { ...state, ...actions, ...getters };
});
